import { render, staticRenderFns } from "./apportionmentTransactionCriteria.vue?vue&type=template&id=52205250&scoped=true&"
import script from "./apportionmentTransactionCriteria.vue?vue&type=script&lang=js&"
export * from "./apportionmentTransactionCriteria.vue?vue&type=script&lang=js&"
import style0 from "./apportionmentTransactionCriteria.vue?vue&type=style&index=0&id=52205250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52205250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VRow,VSwitch})
